import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { useLingui } from '@lingui/react/macro';

interface NutritionItemProps {
  data?: Record<string, string | number | undefined>;
  className?: string;
}

export function NutritionItem({ data, className }: NutritionItemProps) {
  const { t } = useLingui();
  const key = Object.keys(data || {})[0];
  const info = data && data[key];

  const caloriesUnit = t({
    message: 'cal',
    context:
      'Nutrition label: kilocalories (food energy). Short unit abbreviation.'
  });
  const gramsUnit = t({
    message: 'g',
    context: 'Nutrition unit: grams'
  });

  const nutritionMap = {
    nutritionCalories: {
      title: t`Calories`,
      unit: caloriesUnit
    },
    nutritionFat: { title: t`Total Fat`, unit: gramsUnit },
    nutritionCarbs: { title: t`Total Carbs`, unit: gramsUnit },
    nutritionProtein: { title: t`Total Protein`, unit: gramsUnit }
  } as const;

  const { title, unit } = nutritionMap[key as keyof typeof nutritionMap] ?? {};
  const itemText = `${info} ${unit}`;

  return (
    <Show when={Boolean(info && title)}>
      <Component className={className}>
        <Title>{title}</Title>
        <Text>{itemText}</Text>
      </Component>
    </Show>
  );
}

const Component = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  opacity: 0.65;
  font-size: 14px;
  color: #111111;
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #111111;
  margin-top: 6px;
`;
